<template>
    <div class="top_rated container py-5">
        <div class="text-left mb-4">
            <h2 class="">Explore Cities</h2>
            <p class="font2 ft-14">Discover fully furnished houses and apartments for rent in our most popular locations</p>
        </div>

        <div class="row g-4">
            <div class="col-12 col-sm-6 col-md-4 d-flex align-items-center" v-for="city in cities" :key="city.name">
                <img :src="city.image" class="city-image me-3" alt="City Image" />
                <div class="mt">
                    <h5 class="font1 ft-14">{{ city.name }}</h5>
                    <p class="font2 ft-12">More than 7000 properties</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                cities: [
                    { name: "Lagos", image: new URL('@/assets/images/lagos.png', import.meta.url).href },
                    { name: "Abuja", image: new URL('@/assets/images/abuja.png', import.meta.url).href },
                    { name: "Kano", image: new URL('@/assets/images/kano.png', import.meta.url).href },
                    { name: "Enugu", image: new URL('@/assets/images/enugu.png', import.meta.url).href },
                    { name: "Ibadan", image: new URL('@/assets/images/ibadan.png', import.meta.url).href },
                    { name: "Abeokuta", image: new URL('@/assets/images/abeokuta.png', import.meta.url).href }
                ]
            };
        }
    };
</script>

<style scoped>
    .mt{
        margin-top: -20px;
    }
    .city-image {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
    }

    @media (max-width: 576px) {
        .city-image {
            width: 60px;
            height: 60px;
        }
    }

    .font1 {
        font-family: 'CommunityGothicCond';
        font-size: 18px;
        font-weight: 500;
        color: #000000;
    }

    .font2 {
        font-family: 'CommunityGothic';
        font-size: 12px;
        font-weight: 400;
        color: #7B7B7B;
    }

    . {
        font-family: 'CommunityGothicCond';
        font-size: 26px;
        font-weight: 600;
        color: #000000;
    }
</style>
